/* eslint-disable react-refresh/only-export-components */
import { createRoute, createRootRoute, Outlet } from '@tanstack/react-router';
import { DemoLanding } from './DemoLanding';
import TableDemo from './components/TableDemo';
import ColumnsTest from './components/ColumnsTest';
import RoutingDemo from './components/RoutingDemo';
import PostgRESTDemo from './components/PostgRESTDemo';
import { TokenizedInputDemo } from './components/TokenizedInputDemo';
import { EditorDemo } from './components/EditorDemo';
import CheckboxDemo from './components/CheckboxDemo';
import PopoverDemo from './components/PopoverDemo';
import { Button } from '@/components/ui/button';
import { Link } from '@tanstack/react-router';

function DemoLayout() {
  return (
    <div className="bg-background min-h-screen">
      <div className="bg-background/95 border-b backdrop-blur">
        <div className="container mx-auto flex items-center justify-between px-4 py-3">
          <div className="flex items-center space-x-4">
            <h1 className="text-lg font-semibold">Demo Environment</h1>
            <Link to="/">
              <Button variant="ghost" size="sm">
                Demo Home
              </Button>
            </Link>
          </div>
          <a href="/">
            <Button variant="outline" size="sm">
              Back to App
            </Button>
          </a>
        </div>
      </div>
      <div className="container mx-auto">
        <Outlet />
      </div>
    </div>
  );
}

export const demoRootRoute = createRootRoute({
  component: DemoLayout,
});

export const demoIndexRoute = createRoute({
  getParentRoute: () => demoRootRoute,
  path: '/',
  component: DemoLanding,
});

export const tableDemoRoute = createRoute({
  getParentRoute: () => demoRootRoute,
  path: '/table',
  component: TableDemo,
});

export const columnsDemoRoute = createRoute({
  getParentRoute: () => demoRootRoute,
  path: '/columns',
  component: ColumnsTest,
});

export const routingDemoRoute = createRoute({
  getParentRoute: () => demoRootRoute,
  path: '/routing',
  component: RoutingDemo,
});

export const postgrestDemoRoute = createRoute({
  getParentRoute: () => demoRootRoute,
  path: '/postgrest',
  component: PostgRESTDemo,
});

export const tokenizedInputDemoRoute = createRoute({
  getParentRoute: () => demoRootRoute,
  path: '/tokenized-input',
  component: TokenizedInputDemo,
});

export const editorDemoRoute = createRoute({
  getParentRoute: () => demoRootRoute,
  path: '/editor',
  component: EditorDemo,
});

export const checkboxDemoRoute = createRoute({
  getParentRoute: () => demoRootRoute,
  path: '/checkbox',
  component: CheckboxDemo,
});

export const popoverDemoRoute = createRoute({
  getParentRoute: () => demoRootRoute,
  path: '/popover',
  component: PopoverDemo,
});

export const demoRouteTree = demoRootRoute.addChildren([
  demoIndexRoute,
  tableDemoRoute,
  columnsDemoRoute,
  routingDemoRoute,
  postgrestDemoRoute,
  tokenizedInputDemoRoute,
  editorDemoRoute,
  checkboxDemoRoute,
  popoverDemoRoute,
]);
